import { render, staticRenderFns } from "./ManageNotificationList.vue.js?vue&type=template&id=4a536948!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./ManageNotificationList.vue?vue&type=template&id=4a536948"
import script from "./ManageNotificationList.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./ManageNotificationList.vue?vue&type=script&lang=js"
export * from "./ManageNotificationList.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./ManageNotificationList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports